// extracted by mini-css-extract-plugin
export default {"card":"QuestionItem_card__tDDU+","actions":"QuestionItem_actions__OiEd3"};